<template>
  <div>
    <AppLoading :loading="loadingBusca" />
    <AppFormCabecalho titulo="Resultado da Busca" icon="mdi mdi-folder-open" />
    <div class="row align-items-center">
      <div class="col col-lg-6">
        <b-form-select
            size="sm"
            class="col-1"
            :options="[
            { value: 25, text: '25' },
            { value: 50, text: '50' },
            { value: 100, text: '100' }
          ]"
            required
            v-model="filtrar.maximoPorPagina"
        ></b-form-select
        >&nbsp;resultados por página
      </div>
      <div class="col col-lg-6">
        <div class="d-flex align-items-center justify-content-end">
          <b-dropdown
              text="Colunas"
              size="sm"
              variant="outline-secondary"
              class="m-2"
          >
            <a
                class="dropdown-item"
                v-for="(c, idx) in columnsSelect"
                :key="idx"
                href="javascript:void(0)"
                @click.stop="esconderColuna(c)"
            >
              <div class="custom-control custom-checkbox">
                <label class="custom-control-label column-select" :class="{'selected': c.show}">
                  {{ c.title }}
                </label>
              </div>
            </a>
          </b-dropdown>
          <b-dropdown
              text="Ações"
              size="sm"
              variant="outline-secondary"
              class="mr-2"
              :disabled="acoesDisabled"
          >
            <b-dropdown-item
                href="javascript:void(0)"
                :disabled="recarregarEstudoDisabled"
                @click="recarregarEstudo"
            >Recarregar estudos ({{
                totalEstudosSelecionados
              }})</b-dropdown-item
            >
          </b-dropdown>
          <div class="w-50">
            <b-form-input
                type="text"
                id="filtrarNome"
                placeholder="Filtrar pelo Paciente ou Paciente ID"
                v-model="filtrar.nome"
                size="sm"
                autocomplete="off"
            ></b-form-input>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table
        class="estudoTable table table-hover table-bordered table-sm mb-0 nowrap dataTable no-footer border-top-0"
      >
        <thead>
          <tr>
            <th
              v-for="(c, idx) in columns"
              :key="idx"
              :width="c.width"
              :class="c.class"
              @click="sort(c)"
              v-show="c.show"
            >
              {{ c.title }}
            </th>
            <th width="100px" class="text-right" style="padding-right: 14px;">
              <div
                  class="selecionarTodos"
                  title="Selecionar Todos"
                  @click="selecionarTodosEstudos"
              >
                <i
                    class="mdi"
                    :class="{
                    'mdi-checkbox-blank-outline': !selecionarTodos,
                    'mdi-checkbox-marked': selecionarTodos
                  }"
                ></i>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(estudo, idx) in estudosFiltrados">
            <tr :key="idx" @dblclick="carregarSeries(estudo)">
              <td class="text-center">
                <b-button
                  @click="carregarSeries(estudo)"
                  size="sm"
                  variant="outline-secondary"
                  :disabled="estudo.loadingSeries"
                >
                  <i
                    class="mdi"
                    :class="{
                      'mdi-plus-circle':
                        !estudo.mostrarSeries && !estudo.loadingSeries,
                      'mdi-minus-circle':
                        estudo.mostrarSeries && !estudo.loadingSeries,
                      'mdi-spin mdi-loading': estudo.loadingSeries
                    }"
                  ></i>
                </b-button>
              </td>
              <td v-show="showColumn['nomePaciente']">
                {{ estudo.nomePaciente }}
                <div
                  class="text-sm text-muted estudoTable__uid"
                  title="Estudo Instancia UID"
                >
                  {{ estudo.estudoInstanciaUID }}
                </div>
              </td>
              <td v-show="showColumn['descricao']">{{ estudo.descricao }}</td>
              <td v-show="showColumn['totalSerie']">{{ estudo.totalSerie + "/" + estudo.totalImagem }}</td>
              <td v-show="showColumn['dataNascimento']" class="text-center">{{ estudo.dataNascimento }}</td>
              <td v-show="showColumn['sexo']" class="text-center">{{ estudo.sexo }}</td>
              <td v-show="showColumn['pacienteID']">{{ estudo.pacienteID }}</td>
              <td v-show="showColumn['dataHoraEstudo']" class="text-center">{{ estudo.dataHoraEstudo }}</td>
              <td v-show="showColumn['modalidade']">{{ estudo.modalidade[0] }}</td>
              <td v-show="showColumn['dataCriacao']">{{ estudo.dataCriacao }}</td>
              <td v-show="showColumn['numeroAcesso']">{{ estudo.numeroAcesso }}</td>
              <td class="text-center">
                <b-button-group size="sm">
                  <b-button
                    variant="outline-secondary"
                    title="Encaminhar Estudo"
                    @click="encaminharEstudo(estudo)"
                  >
                    <i class="mdi mdi-file-export-outline"></i>
                  </b-button>
                  <b-button
                    variant="outline-secondary"
                    title="Editar Estudo"
                    @click="editarEstudo(estudo)"
                  >
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                  <b-button
                    variant="outline-secondary"
                    title="Apagar Estudo"
                    @click="deletarEstudo(estudo)"
                    :disabled="estudo.loadingRemover"
                  >
                    <i
                      class="mdi text-danger"
                      :class="{
                        'mdi-delete': !estudo.loadingRemover,
                        'mdi-spin mdi-loading': estudo.loadingRemover
                      }"
                    ></i>
                  </b-button>
                  <b-button
                      variant="outline-secondary"
                      title="Selecionar"
                      @click="selecionarEstudo(estudo)"
                  >
                    <i
                        class="mdi"
                        :class="{
                        'mdi-checkbox-blank-outline': !estudo.selecionado,
                        'mdi-checkbox-marked': estudo.selecionado
                      }"
                    ></i>
                  </b-button>
                </b-button-group>
              </td>
            </tr>
            <tr
              :key="estudo.pacienteID"
              v-if="estudo.mostrarSeries"
              style="background-color: #C6F7E2;"
            >
              <td class="border-right-0 estudoTable__line-v"></td>
              <td colspan="10">
                <table
                  class="table table-bordered table-sm mb-0 nowrap dataTable no-footer border-top-0 mx-0 bg-white"
                  style="margin: 0!important"
                >
                  <thead>
                    <tr class="bg-white">
                      <th></th>
                      <th>Data da Serie</th>
                      <th>Serie Instancia UID</th>
                      <th>N&uacute;m. Serie</th>
                      <th>Total Imagens</th>
                      <th>Descri&ccedil;&atilde;o</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(serie, idx) in estudo.series">
                      <tr
                        :key="serie.serieInstanciaUID"
                        @dblclick="carregarInstancias(serie, estudo.servidorId)"
                      >
                        <td
                          class="text-center estudoTable__line-h"
                          width="18px"
                        >
                          <b-button
                            @click="
                              carregarInstancias(serie, estudo.servidorId)
                            "
                            size="sm"
                            variant="outline-secondary"
                            :disabled="serie.loadingInstancias"
                          >
                            <i
                              class="mdi"
                              :class="{
                                'mdi-plus-circle':
                                  !serie.mostrarInstancias &&
                                  !serie.loadingInstancias,
                                'mdi-minus-circle':
                                  serie.mostrarInstancias &&
                                  !serie.loadingInstancias,
                                'mdi-spin mdi-loading': serie.loadingInstancias
                              }"
                            ></i>
                          </b-button>
                        </td>
                        <td>{{ serie.dataHoraSerie | formatDate }}</td>
                        <td>{{ serie.serieInstanciaUID }}</td>
                        <td>{{ serie.numeroSerie }}</td>
                        <td>{{ serie.quantidadeInstancias }}</td>
                        <td>{{ serie.descricao }}</td>
                      </tr>
                      <tr
                        :key="idx"
                        v-if="serie.mostrarInstancias"
                        style="background-color: #EFFCF6;"
                      >
                        <td class="border-right-0 estudoTable__line-v"></td>
                        <td colspan="5">
                          <table
                            class="table table-bordered table-sm mb-0 nowrap dataTable no-footer border-top-0 mx-0 bg-white"
                            style="margin: 0!important"
                          >
                            <thead>
                              <tr class="bg-white">
                                <th>Data de Cria&ccedil;&atilde;o</th>
                                <th>Data de Aquisi&ccedil;&atilde;o</th>
                                <th>SOP Instancia UID</th>
                                <th>Caminho</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(instancia, idx) in serie.instancias"
                                :key="idx"
                              >
                                <td class="estudoTable__line-h">
                                  {{ instancia.dataCriacao | formatDate }}
                                </td>
                                <td>
                                  {{ instancia.dataHoraAquisicao | formatDate }}
                                </td>
                                <td>{{ instancia.sopInstanciaUID }}</td>
                                <td>
                                  <span
                                    class="d-inline-block text-truncate"
                                    style="max-width: 550px;"
                                    v-b-tooltip
                                    :title="instancia.caminhoArquivo"
                                    >{{ instancia.caminhoArquivo }}</span
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-6">
        <p class="text-muted">
          Total de estudos encontrados: {{ totalEstudos }}
        </p>
      </div>
      <div class="col-6">
        <b-pagination
          align="right"
          :total-rows="totalEstudos"
          v-model="filtrar.paginaAtual"
          :per-page="filtrar.maximoPorPagina"
        ></b-pagination>
      </div>
    </div>

    <EditarEstudoForm v-model="editar" :estudo="estudo" />
    <EncaminharEstudo v-model="encaminhar" :estudo="estudoEncaminhar" />
  </div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import BuscarEstudoApi from "../../api/buscarEstudoApi";
import EstudoApi from "../../api/estudoApi";

import AppFormCabecalho from "../layout/AppFormCabecalho.vue";
import AppLoading from "../util/AppLoading.vue";
import EditarEstudoForm from "./EditarEstudoForm.vue";
import EncaminharEstudo from "./EncaminharEstudo.vue";

export default {
  name: "estudoTable",
  components: {
    AppFormCabecalho,
    AppLoading,
    EditarEstudoForm,
    EncaminharEstudo
  },
  props: {
    estudos: Array,
    loadingBusca: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editar: false,
      filtrar: {
        maximoPorPagina: 25,
        nome: "",
        paginaAtual: 1,
        sort: "nomePaciente",
        order: "asc",
        lastColumn: null,
        dateFilter: false
      },
      columns: [
        { title: "", width: "20px", name: "", sorting: false, show: true },
        { title: "Paciente", name: "nomePaciente", class: "sorting", show: true },
        { title: "Descrição", name: "descricao", class: "sorting", show: true },
        { title: "S/I", name: "totalSerie", sorting: false, show: true },
        {
          title: "Data de Nascimento",
          name: "dataNascimento",
          class: "sorting text-center",
          dateFilter: "DD/MM/YYYY", show: true
        },
        { title: "Sexo", name: "sexo", class: "sorting text-center", show: true },
        { title: "Paciente ID", name: "pacienteID", class: "sorting", show: true },
        {
          title: "Data do Estudo",
          name: "dataHoraEstudo",
          class: "sorting text-center",
          dateFilter: "DD/MM/YYYY HH:mm:ss", show: true
        },
        { title: "Modalidade", name: "modalidade", class: "sorting", show: true },
        {
          title: "Data Criação",
          name: "dataCriacao",
          class: "sorting text-center",
          dateFilter: "DD/MM/YYYY HH:mm:ss",
          show: true
        },
        { title: "N\xFAm. Acesso", name: "numeroAcesso", class: "sorting", show: true }
      ],
      mostrar: false,
      tags: [
        { label: "Paciente ID", val: "pacienteID", edit: false },
        { label: "Descrição Estudo", val: "descriacaoEstudo", edit: false },
        { label: "Nome Paciente", val: "nomePaciente", edit: false },
        { label: "Núm. Acesso", val: "numeroAcesso", edit: false },
        { label: "Data Nascimento", val: "dataNascimento", edit: false },
        { label: "Data Estudo", val: "dataEstudo", edit: false },
        { label: "Data Aquisição", val: "dataAquisicao", edit: false }
      ],
      estudo: {
        pacienteID: "",
        descriacaoEstudo: "",
        nomePaciente: "",
        numeroAcesso: "",
        dataNascimento: "",
        dataEstudo: "",
        dataAquisicao: ""
      },
      estudoEncaminhar: {},
      encaminhar: false,
      selecionarTodos: false,
      showColumn: {
        'nomePaciente': true, 'descricao': true, 'totalSerie': true, 'dataNascimento': true, 'sexo': true,
        'pacienteID': true, 'dataHoraEstudo': true, 'modalidade': true, 'dataCriacao': true, 'numeroAcesso': true
      }
    };
  },
  computed: {
    estudosFiltrados() {
      let estudos = this.estudos;
      return estudos
        .sort((a, b) => {
          let modifier = 1;
          if (this.filtrar.order === "desc") modifier = -1;
          if (this.filtrar.dateFilter) {
            const dateA = moment(a[this.filtrar.sort], this.filtrar.dateFilter);
            const dateB = moment(b[this.filtrar.sort], this.filtrar.dateFilter);
            if (dateA.isBefore(dateB)) return -1 * modifier;
            if (dateA.isAfter(dateB)) return 1 * modifier;
          } else {
            if (a[this.filtrar.sort] < b[this.filtrar.sort])
              return -1 * modifier;
            if (a[this.filtrar.sort] > b[this.filtrar.sort])
              return 1 * modifier;
          }
          return 0;
        })
        .filter(row => {
          if (this.filtrar.nome == "") return true;
          let q = _.deburr(this.filtrar.nome).toLowerCase();
          let nomePaciente = _.deburr(row.nomePaciente).toLowerCase();
          let pacienteID = _.deburr(row.pacienteID).toLowerCase();
          return nomePaciente.indexOf(q) >= 0 || pacienteID.indexOf(q) >= 0;
        })
        .filter((row, idx) => {
          let start =
            (this.filtrar.paginaAtual - 1) * this.filtrar.maximoPorPagina;
          let end = this.filtrar.paginaAtual * this.filtrar.maximoPorPagina;
          if (idx >= start && idx < end) return true;
        });
    },
    totalEstudos() {
      return this.estudos.length;
    },
    columnsSelect() {
      return this.columns.filter(c => c.name !== "");
    },
    totalColumnsSelected() {
      return this.columnsSelect.filter(c => c.show).length;
    },
    totalEstudosSelecionados() {
      return this.estudosSelecionados.length;
    },
    estudosSelecionados() {
      return this.estudos.filter(row => {
        return row.selecionado;
      });
    },
    acoesDisabled() {
      return this.totalEstudosSelecionados <= 0;
    },
    recarregarEstudoDisabled(){
      return this.totalEstudosSelecionados === 0;
    }
  },
  watch: {
    mostrarForm(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      this.mostrar = newVal;
      //Remove rolagem do body
      document.body.style.overflow = this.mostrar ? "hidden" : "";
    }
  },
  methods: {
    sort(s) {
      if (s.sorting == false) return;
      const regexSorting = /sorting(_asc)|sorting(_desc)/gm;
      if (this.filtrar.lastColumn !== null)
        this.filtrar.lastColumn.class = this.filtrar.lastColumn.class.replace(
          regexSorting,
          "sorting"
        );
      //if s == current sort, reverse
      if (s.name === this.filtrar.sort) {
        this.filtrar.order = this.filtrar.order === "asc" ? "desc" : "asc";
      }

      const regexSorting2 = /^sorting\s{0,1}|sorting_asc\s{0,1}|sorting_desc\s{0,1}/gm;
      s.class = `sorting_${this.filtrar.order} ${s.class.replace(
        regexSorting2,
        ""
      )}`;
      this.filtrar.sort = s.name;
      this.filtrar.lastColumn = s;
      this.filtrar.dateFilter = s.dateFilter;
    },
    editarEstudo(estudo) {
      this.estudo = { ...estudo };
      this.editar = true;
    },
    encaminharEstudo(estudo) {
      this.estudoEncaminhar = { ...estudo };
      this.encaminhar = true;
    },
    fecharForm() {
      this.mostrar = false;
      this.$emit("change", false);
    },
    escapeKeyListener(evt) {
      if (evt.keyCode === 27 && this.mostrar) {
        this.fecharForm();
      }
    },
    deletarEstudo(estudo) {
      this.$swal({
        title: "Deseja remover o estudo?",
        html: "Esta operação não poderá ser revertida!",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-outline-danger",
        cancelButtonClass: "btn btn-success mr-3",
        buttonsStyling: false,
        confirmButtonText: "Sim, remover estudo!",
        cancelButtonText: "Não, cancelar remoção!",
        reverseButtons: true,
        focusCancel: true,
        focusConfirm: false
      }).then(resp => {
        if (resp.value) {
          const motivo = resp.value;
          const estudoJson = JSON.stringify(estudo);
          this.$set(estudo, "loadingRemover", true);
          EstudoApi.remover(
            estudo.estudoInstanciaUID,
            estudo.servidorId,
            estudoJson,
            motivo
          )
            .then(() => {
              const idx = this.estudos.indexOf(estudo);
              this.estudos.splice(idx, 1);
              this.$set(estudo, "loadingRemover", false);
            })
            .catch(e => {
              console.log(e);
              this.$set(estudo, "loadingRemover", false);
            });
        }
      });
    },
    carregarSeries(estudo) {
      if (estudo.mostrarSeries && estudo.mostrarSeries === true) {
        this._mostrarSeries(false, estudo);
        return;
      }
      if (estudo.loadingSeries) return;
      this._loadingSeries(true, estudo);

      let params = {
        estudoInstanciaUID: estudo.estudoInstanciaUID,
        servidor: estudo.servidorId
      };
      BuscarEstudoApi.series(params)
        .then(resp => {
          this._mostrarSeries(true, estudo);
          this.$set(estudo, "series", resp.data);
          this._loadingSeries(false, estudo);
        })
        .catch(() => {
          this._loadingSeries(false, estudo);
        });
    },
    carregarInstancias(serie, servidorId) {
      if (serie.mostrarInstancias && serie.mostrarInstancias === true) {
        this._mostrarInstancias(false, serie);
        return;
      }
      if (serie.loadingInstancias) return;
      this._loadingInstancias(true, serie);

      let params = {
        serieInstanciaUID: serie.serieInstanciaUID,
        servidor: servidorId
      };
      BuscarEstudoApi.instancias(params)
        .then(resp => {
          this._mostrarInstancias(true, serie);
          this.$set(serie, "instancias", resp.data);
          this._loadingInstancias(false, serie);
        })
        .catch(() => {
          this._loadingInstancias(false, serie);
        });
    },
    esconderColuna(coluna) {
      if (this.totalColumnsSelected === 1 && !!coluna.show) return;
      coluna.show = !coluna.show;
      this.showColumn[coluna.name] = coluna.show;
      this._saveColumnsConfig();
    },
    selecionarEstudo(estudo) {
      this.$set(estudo, "selecionado", !estudo.selecionado);
    },
    selecionarTodosEstudos() {
      this.selecionarTodos = !this.selecionarTodos;
      this.estudosFiltrados.forEach(estudo => {
        this.$set(estudo, "selecionado", this.selecionarTodos);
      });
    },
    async recarregarEstudo(){
      this.$notify({
        group: "geral",
        type: "info",
        title: "Processo iniciado!",
        text: "O processo para recarregar o estudo foi inicializado."
      });
      await this._recarregarVarios();
    },
    _loadingSeries(status, estudo) {
      if (Object.prototype.hasOwnProperty.call(estudo, "loadingSeries")) {
        estudo["loadingSeries"] = status;
      } else {
        this.$set(estudo, "loadingSeries", status);
      }
    },
    _mostrarSeries(status, estudo) {
      if (Object.prototype.hasOwnProperty.call(estudo, "mostrarSeries")) {
        estudo["mostrarSeries"] = !estudo["mostrarSeries"];
      } else {
        this.$set(estudo, "mostrarSeries", status);
      }
    },
    _loadingInstancias(status, serie) {
      if (Object.prototype.hasOwnProperty.call(serie, "loadingInstancias")) {
        serie["loadingInstancias"] = status;
      } else {
        this.$set(serie, "loadingInstancias", status);
      }
    },
    _mostrarInstancias(status, serie) {
      if (Object.prototype.hasOwnProperty.call(serie, "mostrarInstancias")) {
        serie["mostrarInstancias"] = !serie["mostrarInstancias"];
      } else {
        this.$set(serie, "mostrarInstancias", status);
      }
    },
    _saveColumnsConfig(){
      localStorage.setItem("colConfig", JSON.stringify(this.showColumn));
    },
    _getColumnsConfig(){
      let config = localStorage.getItem("colConfig");
      if(!config || config === "") return;
      this.showColumn = JSON.parse(config);
      for(const name in this.showColumn){
        let column = this.columns.find(c => c.name === name);
        if(column) column.show = this.showColumn[name];
      }
    },
    async _recarregarVarios(){
      this.progressoRecarregarVarios = 0;

      let promises = [];
      this.estudosSelecionados.forEach(estudo => {
        promises.push(EstudoApi.recarregarEstudo(
            estudo.estudoInstanciaUID
        ).then(() => {
          this.$emit("ultima-busca");
        }));
      });

      let pos = 1;
      try {
        await promises.reduce(async (previousPromise, nextAsyncFunction) => {
          await previousPromise;
          await nextAsyncFunction;
          let perc = Math.ceil((pos * 100) / this.totalEstudosSelecionados);
          this.progressoRecarregarVarios = perc;
          pos++;
        }, Promise.resolve());

        this.$notify({
          group: "geral",
          type: "success",
          title: "Estudo recarregado!",
          text: "O estudo foi recarregado com sucesso."
        });
      } catch (e) {
        this.progressoRecarregarVarios = 100;
        console.log(e);
        this.$notify({
          group: "geral",
          type: "error",
          title: "Ops!",
          text: "Ocorreu um erro ao recarregar os estudos."
        });
      }
    },
  },
  filters: {
    formatDate(value) {
      if (!value) return "";
      value = moment(value).format("DD/MM/YYYY HH:mm:ss");
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  created() {
    document.addEventListener("keyup", this.escapeKeyListener);
    this._getColumnsConfig();
    //this.debouncedGetAnswer = _.debounce(this.getAnswer, 500)
  },
  destroyed() {
    document.removeEventListener("keyup", this.escapeKeyListener);
  }
};
</script>
<style lang="scss" scoped>
.editarDicom {
  position: fixed;
  width: 50%;
  top: 41px;
  bottom: 0;
  right: 0;
  background-color: #fff;
  z-index: 1041;
  border-left: 1px solid #e3e3e3;
  display: flex;
  flex-direction: column;
  flex: 0;
  .wbs-form-header {
    padding: 10px 10px 0 10px;
  }
  @include element("conteudo") {
    padding: 10px;
    flex: 1;
  }
  @include element("footer") {
    padding: 10px;
    flex: 0;
    border-top: 1px solid #e3e3e3;
  }
}
.editarDicom__backdrop {
  opacity: 0.5;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}
.estudoTable {
  border: 1px solid #dee2e6;
  .estudoTable__uid {
    font-size: 0.7rem;
  }
}
.estudoTable__line-v {
  position: relative;
  &:after {
    content: "";
    border: 1px solid;
    top: 0;
    bottom: 0;
    position: absolute;
    left: 49%;
    color: #829ab1;
  }
}
.estudoTable__line-h {
  position: relative;
  &:after {
    content: "";
    border: 1px solid;
    top: 49%;
    left: -28px;
    position: absolute;
    width: 28px;
    color: #829ab1;
  }
}
.selecionarTodos {
  cursor: pointer;
  display: inline-block;
  &:hover {
    color: #555758;
  }
}
.column-select{
  &.selected::after{
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
  }

  &.selected::before{
    background-color: #3D9970;
  }
}
</style>
